import React, { Component } from 'react';
import '../App.css';
import Logo from '../components/widgets/Logo';
import MobileFooter from '../components/widgets/MobileFooter';
import { signOutUser } from '../redux/actions/user-actions';
import { firebase } from '../firebase';
import Countdown from 'react-countdown-now';
import { Redirect } from 'react-router-dom';

class LogoutPage extends Component {
  logout = () => {
    firebase.auth.signOut().then(function() {
      signOutUser();
    });
    return true;
  };

  redirect = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <Redirect to="/" />;
    } else {
      return <span>{seconds}</span>;
    }
  };

  componentDidMount() {
    this.logout();
  }

  render() {
    return (
      <React.Fragment>
        <Logo />
        <h1 className="not-found-page">
          Thank you for using Inflo today!
          <p style={{fontSize: 18, fontWeight: 200, marginTop: 28}}>
          Come back soon!
          </p>
          <p style={{fontSize: 18, fontWeight: 200,}}>
            Redirecting you to home page in&nbsp;
            <Countdown date={Date.now() + 3000} renderer={this.redirect} />
          </p>
        </h1>
        <MobileFooter />
      </React.Fragment>
    );
  }
}

export default LogoutPage;
